import { useQuery } from '@tanstack/react-query';
import { GetAllEvents } from '../api/api';

export const useEvents = () => {
  return useQuery({
    queryKey: ['events'],
    queryFn: async () => {
      const { data, error } = await GetAllEvents();
      if (error) throw new Error(error);
      return data;
    },
  });
};
